import { instance } from '../helper/api'

export const get = async param => {
  let paramValue = null
  if (param) {
    paramValue = JSON.parse(param)
  }

  let resultData = {}
  const axiosConfig = {
    url: '/v1/vendor/x-api-key/',
    params: paramValue
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getDahboard = async () => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/dashboard/profile/',
    method: 'GET'
  }

  try {
    const results = await instance.request(axiosConfig)
    resultData = results.data.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getOnlineStore = async () => {
  // let resultData = {}
  // const axiosConfig = {
  //   url: '/v1/vendor/online-store/',
  //   method: 'GET'
  // }

  // try {
  //   const results = await instance.request(axiosConfig)
  //   resultData = results.data.data
  // } catch (error) {
  //   if (error.response) {
  //     return error.response.data
  //   } else {
  //     return error.message
  //   }
  // }

  return {
    online_store: {
      id: 172,
      vendor_id: 258,
      address: 'Jalan',
      country_id: 62,
      province_id: 17,
      district_id: 48,
      subdistrict_id: 673,
      logo: 'VdskfHUVzkU8BMmtePQ7Uq0rRemW1p2u/vendor/online-storefb8b6974-e683-4a2f-a10c-b9bb0e293b65.png',
      favicon:
        'VdskfHUVzkU8BMmtePQ7Uq0rRemW1p2u/vendor/online-store2c4f839d-8f91-4305-9ce2-ba7784300498.jpg',
      website_color: '#000000',
      title: 'Exceliconstore',
      slogan: 'E Shopping',
      email: 'redicon@mail.com',
      wa1: '6281806645256',
      wa2: null,
      wa3: null,
      website: null,
      socmed_fb: null,
      socmed_yt: null,
      socmed_x: null,
      socmed_tt: null,
      socmed_ig: null,
      socmed_other: null,
      mp_shopee: null,
      mp_tokopedia: null,
      mp_bukalapak: null,
      mp_lazada: null,
      mp_blibli: null,
      mp_olx: null,
      mp_other: null,
      url_playstore: null,
      url_appstore: null,
      is_web_maintenance: false,
      is_android_maintenance: false,
      is_ios_maintenance: false,
      maintenance_text: null,
      theme_type: 'online_store',
      created_at: '2025-01-15T14:00:33.325394Z',
      created_by: 451,
      updated_at: '2025-01-16T20:58:00.029964Z',
      updated_by: 451
    },
    address: {
      country: {
        id: 62,
        name: 'INDONESIA',
        latitude: -2.4653425298331,
        longitude: 118.01509320579,
        created_at: '2024-02-21T09:46:11.115817Z',
        created_by: 0,
        updated_at: '0001-01-01T00:00:00Z',
        updated_by: null
      },
      province: {
        id: 17,
        country_id: 62,
        name: 'Kepulauan Riau',
        latitude: 0,
        longitude: 0,
        postal: '',
        created_at: '2024-02-21T09:46:16.505553Z',
        created_by: 0,
        updated_at: '2024-02-21T09:46:16.505553Z',
        updated_by: null
      },
      district: {
        id: 48,
        province_id: 17,
        name: 'Batam',
        latitude: 0,
        longitude: 0,
        postal: '',
        created_at: '2024-02-21T09:46:17.571668Z',
        created_by: 0,
        updated_at: '2024-02-21T09:46:17.571668Z',
        updated_by: null
      },
      sub_district: {
        id: 673,
        district_id: 48,
        name: 'Batam Kota',
        latitude: 0,
        longitude: 0,
        postal: '',
        created_at: '2023-11-13T23:46:24Z',
        created_by: 0,
        updated_at: '2023-11-13T23:46:24Z',
        updated_by: null
      }
    }
  }
}
